(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5551],{

/***/ 1752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2156)


/***/ }),

/***/ 2410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["moreSpace", "imgTopDesktopPosition"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.spaces */ .r.spaces;
var StyledBottomBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerContainer",
  componentId: "sc-rgywhc-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;width:100%;margin-bottom:", "px;margin-top:", "px;@media ", "{margin-bottom:", "px;margin-top:", "px;}"], spaces.large24X, spaces.large24X, devices.tablet, spaces.large9X, spaces.large9X);
var StyledDisclaimer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledDisclaimer",
  componentId: "sc-rgywhc-1"
})(["max-width:", "px;width:100%;text-align:center;margin-top:", "px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";@media ", "{padding-left:", "px;padding-right:", "px;}"], spaces.large24X * 10 + 80, spaces.regular, fontSizes.regular, colors.gray[500], devices.tablet, spaces.regular, spaces.regular); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBottomBannerSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var moreSpace = _ref.moreSpace,
      imgTopDesktopPosition = _ref.imgTopDesktopPosition,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerSection",
  componentId: "sc-rgywhc-2"
})(["display:flex;justify-content:space-between;background:", ";border-radius:40px;max-width:", "px;width:100%;padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;.header{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-bottom:", "px;margin-right:", "px;}.footer{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";display:flex;flex-direction:row;justify-content:space-between;align-items:center;}.column1{padding-right:", "px;}.column2{margin-top:", ";margin-bottom:-60px;margin-right:-55px;}@media ", "{margin-left:0;margin-right:0;border-radius:0px;box-shadow:0px 30px 80px rgba(0,0,0,0.05);padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;align-items:center;.header{font-size:", "px;line-height:150%;margin-bottom:", "px;margin-right:", "px;}.footer{font-size:", "px;line-height:24px;flex-direction:column;align-items:flex-start;gap:10px;}.column2{margin:0;img{height:120px;}}}"], colors.blue[600], spaces.large24X * 10 + 80, spaces.large14X, spaces.large14X, spaces.large9X, spaces.large9X, fontSizes.large11X, colors.white, function (_ref2) {
  var moreSpace = _ref2.moreSpace;
  return moreSpace ? spaces.large4X : spaces.medium;
}, spaces.large14X, fontSizes.large, colors.blue[100], spaces.regular, function (_ref3) {
  var imgTopDesktopPosition = _ref3.imgTopDesktopPosition;
  return imgTopDesktopPosition || 0;
}, devices.tablet, spaces.regular, spaces.regular, spaces.large, spaces.large, fontSizes.large, function (_ref4) {
  var moreSpace = _ref4.moreSpace;
  return moreSpace ? spaces.regular : spaces.smallX;
}, spaces.smallX, fontSizes.regular);

var BottomBannerSection = function BottomBannerSection(_ref5) {
  var header = _ref5.header,
      footer = _ref5.footer,
      imgSrc = _ref5.imgSrc,
      imgTopDesktopPosition = _ref5.imgTopDesktopPosition,
      moreSpace = _ref5.moreSpace,
      disclaimer = _ref5.disclaimer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerSection, {
      imgTopDesktopPosition: imgTopDesktopPosition,
      moreSpace: moreSpace,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "column1",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "header",
          children: header
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "footer",
          children: footer
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "column2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
            srcSet: imgSrc,
            type: "image/png"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: imgSrc,
            alt: "Banner image"
          })]
        })
      })]
    }), disclaimer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDisclaimer, {
      children: "All information submitted to Trademark Genius shall be regarded as strictly confidential. Trademark Genius will not reveal any intellectual property information to any organization other than as necessary for submission to the USPTO."
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BottomBannerSection);

/***/ }),

/***/ 3779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(934);
/* harmony import */ var _components_atomic_PriceBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1219);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6668);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);







var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledPriceSection = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceSection",
  componentId: "sc-zxr9wt-0"
})(["max-width:", "px;width:100%;margin-bottom:", "px;@media ", "{margin-left:0;margin-right:0;margin-bottom:", "px;}"], spaces.large24X * 10 + 80, spaces.large24X, devices.tablet, spaces.large9X);
var StyledPriceBannerBadgeTextContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerBadgeTextContainer",
  componentId: "sc-zxr9wt-1"
})(["padding-top:", "px;padding-left:", "px;padding-right:", "px;font-family:'Aeonik';font-style:normal;font-weight:700;font-size:", "px;line-height:130%;color:", ";"], spaces.large, spaces.large9X, spaces.large9X, fontSizes.large12X + 2, colors.white);
var StyledPriceBannerBadgeSubtextContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerBadgeSubtextContainer",
  componentId: "sc-zxr9wt-2"
})(["padding-top:", "px;padding-left:", "px;padding-right:", "px;padding-bottom:", "px;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;color:", ";text-align:center;"], spaces.small2X, spaces.large7X, spaces.large7X, spaces.large3X, fontSizes.large, colors.white);
var StyledPriceBannerTitleContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerTitleContainer",
  componentId: "sc-zxr9wt-3"
})(["display:flex;flex-direction:column;align-items:flex-start;margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";span{display:block;width:100%;}span:last-child{margin-top:", "px;font-size:", "px;line-height:150%;}@media ", "{margin-top:", "px;margin-bottom:", "px;text-align:center;font-size:", "px;}"], spaces.large6X, fontSizes.large11X, colors.white, spaces.smallX, fontSizes.regular, devices.tablet, spaces.regular, spaces.large2X, fontSizes.large2X);
var StyledPriceBannerBodyContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerBodyContainer",
  componentId: "sc-zxr9wt-4"
})(["@media ", "{margin-bottom:", "px;}"], devices.tablet, spaces.smallX);
var StyledBullet = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledBullet",
  componentId: "sc-zxr9wt-5"
})(["display:flex;align-items:center;margin-bottom:", "px;&:last-child{margin-bottom:", "px;}"], spaces.small - 2, spaces.large2X);
var StyledBulletIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledBulletIconContainer",
  componentId: "sc-zxr9wt-6"
})(["margin-right:", "px;"], spaces.small);
var StyledBulletText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledBulletText",
  componentId: "sc-zxr9wt-7"
})(["flex-grow:1;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";@media ", "{font-size:", "px;}"], fontSizes.large, colors.white, devices.tablet, fontSizes.regular);
var StyledUnderBulletsText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledUnderBulletsText",
  componentId: "sc-zxr9wt-8"
})(["margin-top:", "px;flex-grow:1;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:300;color:", ";font-style:italic;@media ", "{margin-top:", "px;}"], spaces.large4X, fontSizes.regular, colors.white, devices.tablet, spaces.large2X);

var PriceSection = function PriceSection(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      price = _ref.price,
      priceText = _ref.priceText,
      bullets = _ref.bullets,
      underBulletsText = _ref.underBulletsText,
      buttons = _ref.buttons;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceSection, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_atomic_PriceBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      notRoundedMobile: true,
      innerSpace: spaces.large9X,
      roundingRadius: 40,
      footer: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledUnderBulletsText, {
        children: underBulletsText
      }),
      badgeRoundingRadius: 30,
      color: {
        gradient: {
          from: colors.blue[600],
          to: colors.blue[500]
        }
      },
      title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledPriceBannerTitleContainer, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          children: subtitle
        })]
      }),
      badgeText: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceBannerBadgeTextContainer, {
        children: "$".concat((price === null || price === void 0 ? void 0 : price.toFixed(2)) || '0.00')
      }),
      badgeSubtext: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceBannerBadgeSubtextContainer, {
        children: priceText
      }),
      buttons: buttons,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceBannerBodyContainer, {
        children: bullets === null || bullets === void 0 ? void 0 : bullets.map(function (bullet, idx) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledBullet, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBulletIconContainer, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alias: _constants_icons__WEBPACK_IMPORTED_MODULE_1__/* .ICONS_ALIASES.checkRounded */ .F.checkRounded,
                color: colors.white
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBulletText, {
              children: bullet
            })]
          }, "bullet:".concat(idx));
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceSection);

/***/ }),

/***/ 5243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RequestForExtension; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_components/atomic/layouts/form/index.js + 8 modules
var layouts_form = __webpack_require__(2890);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./_components/composed/sections/BaseBannerSection/index.jsx
var BaseBannerSection = __webpack_require__(317);
// EXTERNAL MODULE: ./_components/composed/sections/BottomBannerSection/index.jsx
var BottomBannerSection = __webpack_require__(2410);
// EXTERNAL MODULE: ./_components/atomic/Button/index.jsx
var Button = __webpack_require__(8509);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./_constants/routes.js
var routes = __webpack_require__(672);
// EXTERNAL MODULE: ./_components/composed/sections/PriceSection/index.jsx
var PriceSection = __webpack_require__(3779);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./_redux/variants/selector.js
var selector = __webpack_require__(6058);
// EXTERNAL MODULE: ./_constants/processing.js
var processing = __webpack_require__(2685);
// EXTERNAL MODULE: ./_constants/products.js
var products = __webpack_require__(3193);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/composed/pages/RequestForExtensionPage/index.jsx


var _excluded = ["size", "rotate", "top", "bottom", "left", "right"],
    _excluded2 = ["top", "bottom", "left", "right"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    spaces = theme/* theme.spaces */.r.spaces;
var StyledRequestForExtensionPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RequestForExtensionPage__StyledRequestForExtensionPage",
  componentId: "sc-1dmsdft-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;@media ", "{display:block;}"], devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCircle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "RequestForExtensionPage__StyledCircle",
  componentId: "sc-1dmsdft-1"
})(["position:absolute;background:", ";border-radius:50%;opacity:0.1;z-index:-1;", " ", " ", " ", " ", " ", " @media ", "{display:none;}"], "linear-gradient(180deg, ".concat(theme/* theme.colors.blue.500 */.r.colors.blue[500], " 0%, rgba(46, 144, 250, 0) 100%)"), function (_ref2) {
  var top = _ref2.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref4) {
  var left = _ref4.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref5) {
  var right = _ref5.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && (0,styled_components_browser_esm/* css */.iv)(["transform:", ";"], "rotate(".concat(rotate, "deg)"));
}, function (_ref7) {
  var size = _ref7.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["width:", "px;height:", "px;"], size, size);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.devices.tablet;
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref9, ref) {
  var top = _ref9.top,
      bottom = _ref9.bottom,
      left = _ref9.left,
      right = _ref9.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "RequestForExtensionPage__StyledImageContainer",
  componentId: "sc-1dmsdft-2"
})(["position:absolute;z-index:-1;", " ", " ", " ", " @media ", "{display:none;}"], function (_ref10) {
  var top = _ref10.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref11) {
  var bottom = _ref11.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref12) {
  var left = _ref12.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref13) {
  var right = _ref13.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.devices.tablet;
});

var RequestForExtensionPage = function RequestForExtensionPage() {
  var router = (0,next_router.useRouter)();
  var priceMapByStandardProcessing = (0,es/* useSelector */.v9)((0,selector/* selectPriceMapByProcessingCode */.Ej)(processing/* PROCESSING_OPTIONS_KEYS.standard */.I.standard));
  var productPrice = priceMapByStandardProcessing[products/* PRODUCT_CODES.tmExtension */.P.tmExtension];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledRequestForExtensionPage, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BaseBannerSection/* default */.Z, {
      hideImageMobile: true,
      imgSrc: "".concat(publicRuntimeConfig.basePath, "/images/request-for-extension.svg"),
      title: "File Your Statement of Use Extension Online",
      text: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["Need more time to file your Trademark Statement of Use Extension with the USPTO?", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Let us help you extend your deadline for another six months."]
      }),
      buttons: [{
        text: 'Start my extension filing',
        color: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        onClick: function onClick() {
          return router.push(routes/* ROUTES.requestForExtensionFiling */.Z.requestForExtensionFiling);
        },
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: colors.white
        })
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layouts_form/* Divider */.iz, {
      desktop: true,
      size: spaces.large24X
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceSection/* default */.Z, {
      title: "Request for Extension",
      subtitle: "NEED MORE TIME TO FILE YOUR STATEMENT OF USE? WE CAN HELP EXTEND THE DEADLINE FOR ANOTHER 6 MONTHS.",
      price: productPrice,
      priceText: "USPTO gov fees",
      bullets: ['Expert handling with strict adherence to USPTO guidelines', 'Consistent updates and guidance'],
      buttons: [{
        text: 'Start my extension filing',
        color: colors.white,
        textColor: colors.blue[500],
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: colors.blue[500]
        }),
        onClick: function onClick() {
          return router.push(routes/* ROUTES.requestForExtensionFiling */.Z.requestForExtensionFiling);
        }
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Don't wait, Protect Your Brand now"
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
        }),
        color: theme/* theme.colors.white */.r.colors.white,
        onClick: function onClick() {
          return router.push(routes/* ROUTES.requestForExtensionFiling */.Z.requestForExtensionFiling);
        },
        textColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        hoverColor: theme/* theme.colors.white */.r.colors.white,
        hoverTextColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        children: "Start my extension filing"
      }),
      imgSrc: "".concat(publicRuntimeConfig.basePath, "/images/trademark-registration-bottom.svg"),
      imgTopDesktopPosition: "-130px",
      moreSpace: true,
      disclaimer: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: 360,
      left: -274,
      top: 'calc(50% + 20px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 65,
      top: 'calc(69% + 14px)',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    })]
  });
};

/* harmony default export */ var pages_RequestForExtensionPage = (RequestForExtensionPage);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/request-for-extension.js





function RequestForExtension() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "Request for Extension"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages_RequestForExtensionPage, {})]
  });
}

/***/ }),

/***/ 9896:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-for-extension",
      function () {
        return __webpack_require__(5243);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ./node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ./node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2890,1336,9774,2888,179], function() { return __webpack_exec__(9896); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);